<template>
  <v-card class="" tile v-if="species">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          <h4>Fakta</h4>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <!-- <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Single-line item</v-list-item-title>
      </v-list-item-content>
    </v-list-item> -->

    <v-list-item v-if="species.name_sve">
      <v-list-item-content>
        <v-list-item-subtitle>Namn</v-list-item-subtitle>
        <v-list-item-title>{{ species.name_sve }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="species.name_lat">
      <v-list-item-content>
        <v-list-item-subtitle>Latinskt namn</v-list-item-subtitle>
        <v-list-item-title>{{ species.name_lat }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="species.size">
      <v-list-item-content>
        <v-list-item-subtitle>Storlek</v-list-item-subtitle>
        <v-list-item-title>{{ species.size }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="species.category">
      <v-list-item-content>
        <v-list-item-subtitle>Grupp</v-list-item-subtitle>
        <v-list-item-title>{{ species.category }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="species.life_group">
      <v-list-item-content>
        <v-list-item-subtitle>Undergrupp</v-list-item-subtitle>
        <v-list-item-title>{{ species.life_group }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="species.name_other_sve">
      <v-list-item-content>
        <v-list-item-subtitle>Andra namn</v-list-item-subtitle>
        <v-list-item-title>{{ species.name_other_sve }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="species.freshwater || species.marine">
      <v-list-item-content>
        <v-list-item-subtitle>Ursprung</v-list-item-subtitle>
        <v-list-item-title v-if="species.freshwater === 'on'"
          >Sötvatten</v-list-item-title
        >
        <v-list-item-title v-if="species.marine === 'on'"
          >Marin miljö</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="hasMoreInfo">
      <v-list-item-content>
        <v-list-item-subtitle>Övrigt</v-list-item-subtitle>
        <v-list-item-title v-if="species.alien === 'on'"
          >Främmande art</v-list-item-title
        >
        <v-list-item-title v-if="species.redlist_nt === 'on'"
          >Arten är <a href="/livet/arter/rodlistade-arter">rödlistad</a> i
          kategorin Nära hotad</v-list-item-title
        >
        <v-list-item-title v-if="species.redlist_vu === 'on'"
          >Arten är <a href="/livet/arter/rodlistade-arter">rödlistad</a> i
          kategorin Sårbar</v-list-item-title
        >
        <v-list-item-title v-if="species.redlist_cr === 'on'"
          >Arten är <a href="/livet/arter/rodlistade-arter">rödlistad</a> i
          kategorin Akut hotad</v-list-item-title
        >
        <v-list-item-title v-if="species.redlist_en === 'on'"
          >Arten är <a href="/livet/arter/rodlistade-arter">rödlistad</a> i
          kategorin Starkt hotad</v-list-item-title
        >
        <v-list-item-title v-if="species.redlist_re === 'on'"
          >Arten är <a href="/livet/arter/rodlistade-arter">rödlistad</a> i
          kategorin Nationellt utdöd</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>

    <EnvironmentFact :species="species" />
  </v-card>
</template>

<script>
import EnvironmentFact from '@/components/SingleSpeciesEnvironmentMap'
export default {
  name: 'SpeciesFacts',
  components: {
    EnvironmentFact
  },
  props: {
    species: { type: Object, required: true }
  },
  computed: {
    hasMoreInfo() {
      return (
        this.species.alien === 'on' ||
        this.species.redlist_nt === 'on' ||
        this.species.redlist_vu === 'on' ||
        this.species.redlist_cr === 'on' ||
        this.species.redlist_en === 'on' ||
        this.species.redlist_re === 'on'
      )
    }
  }
}
</script>

<style lang="css" scoped>
.v-list-item__content {
  padding-top: 0px !important;
  padding-bottom: 5px !important;
}
</style>
